export const isMainnet = process.env.REACT_APP_MAINNET === 'true'
export const WalletConnectProjectId = process.env.REACT_APP_WALLECT_CONNECT_PROJECTID

